import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Layout from '@/views/Layout/'
import Main from '@/views/Layout/main.vue'
import {
  getItem,
  setItem
} from '@/untils/storage'
import store from '@/store'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    children: [ //NewProblem
      {
        path: '/NewProblem',
        name: 'NewProblem',
        component: () => import('@/views/ProblemFeedback/Problem/NewProblem.vue')
      },/* 新建问题 */
      {
        path: '/Authentication',
        name: 'Authentication',
        component: () => import('@/views/UserCenter/Authentication/index.vue')
      },/* 提交个人认证 */
      {
        path: '/SubmPersonal',
        name: 'SubmPersonal',
        component: () => import('@/views/UserCenter/Authentication/SubmPersonal.vue')
      },/* 提交个人认证 */
      {
        path: '/userAuthentication',
        name: 'userAuthentication',
        component: () => import('@/views/UserCenter/Authentication/user.vue')
      },/* 个人认证信息 */
      {
        path: '/SubmEnterprise',
        name: 'SubmEnterprise',
        component: () => import('@/views/UserCenter/Authentication/SubmEnterprise.vue')
      },/* 提交企业认证 */
      {
        path: '/enterprise',
        name: 'enterprise',
        component: () => import('@/views/UserCenter/Authentication/enterprise.vue')
      },/* 企业认证信息 */
      {
        path: '/CancellationOrder',
        name: 'CancellationOrder',
        component: () => import('@/views/Cost/Myorder/CancellationOrder.vue')
      },/* 取消 */
      {
        path: '/ImmediatePayment',
        name: 'ImmediatePayment',
        component: () => import('@/views/Cost/Myorder/ImmediatePayment.vue')
      },/* 支付订单 */
      {path: '/OrderDetails', name: 'OrderDetails', component: () => import('@/views/Cost/Myorder/OrderDetails.vue')},/* 订单详情 */
      // {path : '/AccountNumber',name :'AccountNumber',component: () => import('@/views/Differential/AccountNumber')},/* 订单详情 */
      // {path : '/maintainOrder',name :'maintainOrder',component: () => import('@/views/maintainOrder/Myorder/')},/* 运维订单管理 */
      {
        path: '/MaintainPriceChange',
        name: 'MaintainPriceChange',
        component: () => import('@/views/maintainOrder/Myorder/MaintainPriceChange.vue')
      },/* 运维改价订单 */
      {
        path: '/MainDetail',
        name: 'OrderDetails',
        component: () => import('@/views/maintainOrder/Myorder/MainDetail.vue')
      },/* 运维订单详情 */
      {
        path: '/MaintainCancellationOrder',
        name: 'MaintainCancellationOrder',
        component: () => import('@/views/maintainOrder/Myorder/MaintainCancellationOrder.vue')
      },/* 运维订单详情 */
      {
        path: '/MaintainImmediatePayment',
        name: 'MaintainImmediatePayment',
        component: () => import('@/views/maintainOrder/Myorder/MaintainImmediatePayment.vue')
      },/* 运维订单详情 */
      {
        path: '/MaintainNumber',
        name: 'MaintainNumber',
        component: () => import('@/views/maintainOrder/AccountNumber/')
      },/* 运维账号管理 */
      // {path : '/Coupon',name :'Coupon',component: () => import('@/views/maintainOrder/MainCoupon/')},/* 运维优惠券管理 */
      {
        path: '/NewlyCoupon',
        name: 'Coupon',
        component: () => import('@/views/maintainOrder/MainCoupon/CouponNewlyBuild.vue')
      },/* 运维优惠券新增 */
      {
        path: '/SeeConpon',
        name: 'SeeConpon',
        component: () => import('@/views/maintainOrder/MainCoupon/seeConpon.vue')
      },/* 运维优惠券查看 */
    ]
  }, {
    path: '/main',
    name: 'main',
    component: Main,
    children: [
      {path: '/Number', name: 'Number', component: () => import('@/views/DifferentialService/PurchaseService')},/* 购买服务 */
      {path: '/Renew', name: 'Renew', component: () => import('@/views/DifferentialService/RenewService')},/* 续费服务 */
      {path: '/OrderSubm', name: 'OrderSubm', component: () => import('@/views/DifferentialService/OrderSubm')},/* 订单提交 */
      {path: '/Login', name: 'Login', component: () => import('@/views/Login/login-back.vue')}, /* 登录 */
      {path: '/Register', name: 'Register', component: () => import('@/views/Login/register.vue')}, /* 注册 */
      {path: '/Perfect', name: 'Perfect', component: () => import('@/views/Login/Perfect.vue')}, /* 完善信息 */
      {path: '/ForgetPassword', name: 'ForgetPassword', component: () => import('@/views/Login/ForgetPassword.vue')}, /* 忘记密码 */
      {path: '/Index', name: 'Index', component: () => import('@/views/Index')}, /* 首页 */
      {path: '/ActivityPage', name: 'ActivityPage', component: () => import('@/views/Index/ActivityPage.vue')}, /* 首页 */
      {
        path: '/DifferenceCart',
        name: 'DifferenceCart',
        component: () => import('@/views/DifferentialService/DifferenceCart/back.vue')
      }, /* 差分服务 */
      {path: '/FreeTrial', name: 'FreeTrial', component: () => import('@/views/home-header/FreeTrial')}, /* 免费试用 */
      {path: '/ScopeService', name: 'ScopeService', component: () => import('@/views/home-header/ScopeService')}, /* 服务范围查询 */
      {
        path: '/SuccessfulCase', name: 'SuccessfulCase', component: () => import('@/views/home-header/SuccessfulCase'),
        children: [
          {path: '/Case', name: 'Case', component: () => import('@/views/home-header/SuccessfulCase/Case')}, /* 燃气成功案例 */
          {path: '/Drainage', name: 'Drainage', component: () => import('@/views/home-header/SuccessfulCase/drainage')}, /* 燃气成功案例 */
          {
            path: '/HeatSupply',
            name: 'HeatSupply',
            component: () => import('@/views/home-header/SuccessfulCase/HeatSupply')
          }, /* 燃气成功案例 */
          {path: '/SuccessfulCase', redirect: '/Case'}
        ],

      }, /* 成功案例 */

      {
        path: '/InformationAdvertising',
        name: 'InformationAdvertising',
        component: () => import('@/views/home-header/InformationAdvertising'),
        children: [
          {
            path: '/NewsCenter',
            name: 'NewsCenter',
            component: () => import('@/views/home-header/InformationAdvertising/NewsCenter')
          }, /* 新闻中心 */
          {
            path: '/SystemBulletin',
            name: 'SystemBulletin',
            component: () => import('@/views/home-header/InformationAdvertising/SystemBulletin')
          }, /* 系统公告 */
          {path: '/InformationAdvertising', redirect: '/NewsCenter'},
          {
            path: '/NewsDetailOne',
            name: 'NewsDetailOne',
            component: () => import('@/views/home-header/InformationAdvertising/NewsDetailOne')
          }, /* 新闻1 */
          {
            path: '/NewsDetailTwo',
            name: 'NewsDetailTwo',
            component: () => import('@/views/home-header/InformationAdvertising/NewsDetailTwo')
          }, /* 新闻2 */
          {
            path: '/NewsDetailThree',
            name: 'NewsDetailThree',
            component: () => import('@/views/home-header/InformationAdvertising/NewsDetailThree')
          }, /* 新闻3 */
          {
            path: '/SystemDetails',
            name: 'SystemDetails',
            component: () => import('@/views/home-header/InformationAdvertising/SystemDetails')
          }, /* 系统供高 */
        ],
      },/* 咨询公告 */
      {
        path: '/HelpCenter', name: 'HelpCenter', component: () => import('@/views/home-header/HelpCenter'),
        children: [
          {
            path: '/SoftwareDownload',
            name: 'SoftwareDownload',
            component: () => import('@/views/home-header/HelpCenter/SoftwareDownload')
          }, /* 软件下载 */
          {
            path: '/VideoCenter',
            name: 'VideoCenter',
            component: () => import('@/views/home-header/HelpCenter/VideoCenter')
          }, /* 视频中心 */
          {
            path: '/CommonProblem',
            name: 'CommonProblem',
            component: () => import('@/views/home-header/HelpCenter/CommonProblem')
          }, /* 常见问题 */
          {
            path: '/HelpDocument',
            name: 'VideoCenter',
            component: () => import('@/views/home-header/HelpCenter/HelpDocument')
          }, /* 帮助文档 */
          {path: '/HelpCenter', redirect: '/SoftwareDownload'}
        ],
      },/* 帮助中心 */
      {
        path: '/AboutUs', name: 'AboutUs', component: () => import('@/views/home-header/AboutUs'),
        children: [
          {path: '/Beidou', name: 'Beidou', component: () => import('@/views/home-header/AboutUs/Beidou.vue')}, /* 北斗精准服务网 */
          {
            path: '/OperationUnit',
            name: 'OperationUnit',
            component: () => import('@/views/home-header/AboutUs/OperationUnit.vue')
          }, /* 运营单位 */
          {
            path: '/ContactInformation',
            name: 'ContactInformation',
            component: () => import('@/views/home-header/AboutUs/ContactInformation.vue')
          }, /* 联系方式 */
          {path: '/AboutUs', redirect: '/Beidou'}
        ],
      }/* 关于我们 */
    ]
  },

]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

const whiteList = ['/Index', '/Login', '/Register', '/Perfect', '/ForgetPassword',
  '/DifferenceCart', '/Number', '/OrderSubm',
  '/FreeTrial',
  '/SuccessfulCase', '/Case', '/Drainage', '/HeatSupply',
  '/InformationAdvertising', '/NewsCenter', '/SystemBulletin',
  '/HelpCenter', '/SoftwareDownload', '/VideoCenter', '/CommonProblem', '/HelpDocument',
  '/NewsDetailOne', '/NewsDetailTwo', '/NewsDetailThree', '/SystemDetails', '/ActivityPage',
  '/AboutUs', '/Beidou', '/OperationUnit', '/ContactInformation',
  '/ScopeService'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  if (getItem('token')) {
    if (to.path === '/Login') {
      next('/Authentication')
    } else {
      if (store.state.user.role.length == 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          const role = res.data.data
          store.dispatch('GenerateRoutes', role).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.state.permission.addRouters) // 动态添加可访问路由表
            next({...to, replace: true}) // hack方法 确保addRoutes已完成
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            next({path: '/'})
          })
        })
      } else {
        /*if (hasPermission(store.getters.role, to.meta.roles)) {
          next()
        } else {
          next({path: '/401', replace: true, query: { noGoBack: true }})
        }*/
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next(`/Login`) // 否则全部重定向到首页
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js